<div
  role="group"
  class="mention-input-container"
  [attr.aria-labelledby]="formField.getLabelId()"
>
  <input
    class="mention-input-element"
    matInput
    type="text"
    [placeholder]="placeholder"
    #mentionInput
    [formControl]="mentionFormControl"
    (keypress)="onKeyPress($event)"
  />
  <div [matMenuTriggerFor]="mentionMenu" style="position: absolute"></div>
  <mat-menu #mentionMenu="matMenu">
    @for (mention of mentions; track mention) {
      <button mat-menu-item (click)="setMentionValue(getMentionValue(mention))">
        {{ getMentionValue(mention) }}
      </button>
    }
  </mat-menu>
</div>
